import { Box, Menu, MenuItem, Typography } from "@mui/material";
import { useStore } from "../../stores/store";
import { NavBarRoute } from "../options/navBarOpt";
interface NavBarMenuProps {
    anchors: [] | HTMLElement[];
    menuId: string;
    handleCloseAnchors: (routeId?: string) => void;
    menuItems: NavBarRoute[];
    isLogout?: boolean;
}

const GenerateNavBarMenuDesktop = ({ anchors, menuId, handleCloseAnchors, menuItems, isLogout }: NavBarMenuProps) => {
    const { userStore } = useStore();
    const { logout } = userStore;
    return (
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            <Menu
                sx={{
                    mt: '20px',
                    '& .MuiPaper-root': {
                        minWidth: 100,
                        bgcolor: '#DAE5F1'
                    }
                }}
                id={menuId}
                anchorEl={anchors.find(x => x.id === menuId)}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchors.some(x => x.id === menuId))}
                onClose={() => handleCloseAnchors()}

            >
                {menuItems.map((item) => (
                    <MenuItem key={item.text} onClick={() => { handleCloseAnchors(item.routeId) }
                    }>
                        <Typography textAlign="center">
                            {item.text}
                        </Typography>

                        {/* {(item.text === 'User Roles') &&
                            <Menu
                                id="menu-appbar-admin"
                                // anchorEl={anchorElNav}
                                anchorEl={anchors.find(x => x.id === "menu-appbar-admin")}
                                anchorOrigin={{
                                    vertical: 'center',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchors.some(x => x.id === "menu-appbar-admin"))}
                                // open={Boolean(anchorElNav)}
                                onClose={() => handleCloseAnchors()}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                    '& .MuiPaper-root': {
                                        minWidth: 100,
                                        bgcolor: '#DAE5F1'
                                    }
                                }}
                            >
                                {
                                    userRoles?.map((roles) =>
                                        <MenuItem key={roles.text} onClick={() => {
                                            handleCloseAnchors(roles.routeId)
                                        }}>
                                            {roles.text}
                                        </MenuItem>
                                    )
                                }
                                </Menu>
                        } */}

                    </MenuItem>
                ))
                }
                {isLogout &&
                    <MenuItem key={'logout'} onClick={() => {
                        logout();
                        handleCloseAnchors('/');
                    }}
                    >
                        <Typography textAlign="center">Logout</Typography>
                    </MenuItem>
                }
            </Menu>
        </Box>
    )
}

export default GenerateNavBarMenuDesktop;